import type { CSSProperties } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from "@xyflow/react";
import type { DailyEdge as DailyEdgeType } from "./types";

export function DailyEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: EdgeProps<DailyEdgeType>) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={styles.edgePath} />
      {data?.selected && (
        <EdgeLabelRenderer>
          <button
            type="button"
            style={{
              ...styles.deleteButton,
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            }}
            className="nodrag nopan"
            onClick={() => data.onDelete?.(id)}
            aria-label="Delete connection"
          >
            X
          </button>
        </EdgeLabelRenderer>
      )}
    </>
  );
}

const styles = {
  edgePath: {
    stroke: "var(--accent)",
    strokeWidth: 2,
  },
  deleteButton: {
    position: "absolute",
    width: "22px",
    height: "22px",
    border: "1px solid var(--accent-border)",
    borderRadius: "999px",
    background: "var(--bg)",
    color: "var(--text-h)",
    fontSize: "12px",
    lineHeight: 1,
    cursor: "pointer",
    pointerEvents: "all",
  },
} satisfies Record<string, CSSProperties>;
